import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'

import { CaseCreateEditComponent } from '../../../abacus/components/case-create-edit.component'
import { InputType } from '../../../abacus/enums/input-type.enum'
import { Field } from '../../../abacus/interfaces/field.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { caseCreateEditTemplate } from '../../../abacus/templates/case-create-edit.template'

import { CommonModule } from '@angular/common'
import { CaseInputComponent } from 'src/app/abacus/elements/inputs/case-input/case-input.component'
import { HasPermissionDirective } from 'src/app/abacus/standalone-exports'
import { tagDefinition } from '../tag.definition'

@Component({
    template: caseCreateEditTemplate,
    standalone: true,
    imports: [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      RouterModule,
      HasPermissionDirective,
      CaseInputComponent
    ]
})
export class TagCreateEditComponent
  extends CaseCreateEditComponent
  implements OnInit
{
  definition: ResourceDefinition = tagDefinition
  fields: Field[] = [
    {
      label: 'Name',
      placeholder: 'Enter the name...',
      property: 'name',
      className: 'is-6',
      inputType: InputType.Text,
      required: true
    },
    {
      label: 'Description',
      placeholder: 'Enter the description...',
      property: 'description',
      className: 'is-6',
      inputType: InputType.Text
    },
    {
      label: 'Order',
      placeholder: 'Order of display (higher value appears first)...',
      property: 'order',
      className: 'is-6',
      inputType: InputType.Number
    }
  ]

  constructor(
    formBuilder: UntypedFormBuilder,
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService
  ) {
    super(
      formBuilder,
      router,
      breadcrumbService,
      resourceService,
      flashMessageService,
      activatedRoute
    )
  }

  ngOnInit() {
    this.initCreateEditView()
  }
}
